import React from 'react';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
	ChartOptions,
} from 'chart.js';
import {Bar} from 'react-chartjs-2';
import {useTranslation} from 'react-i18next';
import {monthNow} from '../../assets/utils/dateUtils';
import {useStatMonthVolumeCommandQuery} from '../../redux/myDynamicApi';
import Loader from '../../assets/Animations/PreLoaderComponent/Loader';

ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
);

export type Stat = {
	month: string;
	count_points: number;
};

type Props = {};

const QualificationChartTeamValue: React.FC<Props> = () => {
	const {t} = useTranslation();
	
	const options: ChartOptions<'bar'> = {
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			datalabels: {
				display: false,
			},
			legend: {display: false},
		},
		elements: {
			bar: {
				borderRadius: 10,
			},
		},
		scales: {
			x: {
				title: {
					display: true,
					text: t('Місяці'),
				},
				grid: {
					display: false,
				},
			},
			y: {
				title: {
					display: true,
					text: t('Бали'),
				},
				beginAtZero: true,
				grid: {
					display: false,
				},
			},
		},
	};
	const {data: monthValume, isLoading} =
		useStatMonthVolumeCommandQuery(monthNow());
	const labels = monthValume?.stats?.map((s) =>
		new Date(s.month).toLocaleString('uk-UA', {month: 'long'}),
	);

	const data = {
		labels,
		datasets: [
			{
				label: t('Командний ТО'),
				data: monthValume?.stats?.map((s) => s.count_points),
				backgroundColor: '#98b089',
				borderWidth: 0,
			},
		],
	};
	return (
		<div style={{height: 280}}>
			{isLoading ? <Loader /> : <Bar options={options} data={data} />}
		</div>
	);
};

export default QualificationChartTeamValue;
